import Rebase from 're-base';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyA2GDff-lJpCClsZW61xgycdVXyaZLEvew",
  authDomain: "hot-burgers-shop.firebaseapp.com",
  databaseURL: "https://hot-burgers-shop-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "hot-burgers-shop",
  storageBucket: "hot-burgers-shop.appspot.com",
  messagingSenderId: "139086176407",
  appId: "1:139086176407:web:d33f76b4e14344ea94c9d2"
});

const base = Rebase.createClass(firebaseApp.database());

export { firebaseApp };

export default base;


 